import { render, staticRenderFns } from "./criar-ranf.vue?vue&type=template&id=afb6c866&"
import script from "./criar-ranf.vue?vue&type=script&lang=js&"
export * from "./criar-ranf.vue?vue&type=script&lang=js&"
import style0 from "./criar-ranf.vue?vue&type=style&index=0&id=afb6c866&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports